import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { FilterBoolean } from '../../../models/call-history-filter.models';

@Component({
  selector: 'app-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterDropdownComponent),
      multi: true,
    },
  ],
})
export class FilterDropdownComponent implements ControlValueAccessor {
  @Input() public options: any[];

  public value: string;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: any = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouch: any = () => {};

  public selectedOption: any;

  public selectOption(obj: any) {
    this.selectedOption = obj;
    this.onChange(this.selectedOption);
  }

  writeValue(obj: any): void {
    if (obj) {
      this.selectedOption = obj;
      if (this.selectedOption == FilterBoolean.yes || this.selectedOption == FilterBoolean.no) {
        this.selectedOption == FilterBoolean.yes ? this.onChange(true) : this.onChange(false);
      } else {
        this.onChange(this.selectedOption);
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
